import { render } from "./UtilizationInsightComponent.vue?vue&type=template&id=afe45a1a&scoped=true"
import script from "./UtilizationInsightComponent.vue?vue&type=script&lang=js"
export * from "./UtilizationInsightComponent.vue?vue&type=script&lang=js"

import "./UtilizationInsightComponent.vue?vue&type=style&index=0&id=afe45a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe45a1a"]])

export default __exports__